import PaymentSettings from 'routes/PaymentSettings/PaymentSettings';

export default PaymentSettings;
